import { render, staticRenderFns } from "./sensors.vue?vue&type=template&id=0993ffd8&scoped=true&class=sensors-mainview&"
import script from "./sensors.vue?vue&type=script&lang=js&"
export * from "./sensors.vue?vue&type=script&lang=js&"
import style0 from "./sensors.vue?vue&type=style&index=0&id=0993ffd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0993ffd8",
  null
  
)

export default component.exports